import "./OurProjects.module.css";
import Header from "@/reusable_sections/Header";
import Gallery from "./sections/Gallery";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function OurProjectsPage() {
  return <div>
      <Header />
      <Gallery />
      <Action />
      <Footer />
    </div>;
}